/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint unparam:true */

"use strict";

var slickCore = require("slickgrid/core");

var $ = require("../jquery");

var util = require("./util");

var defaultOptions = {
    groupCssClass: "group-header ",
    totalsCssClass: "slick-group-totals ",
    groupSelectable: true,
    groupFocusable: true,
    totalsSelectable: false,
    totalsFocusable: false,
    toggleCssClass: "slick-group-toggle",
    toggleExpandedCssClass: "expanded",
    toggleCollapsedCssClass: "collapsed",
    checkboxCssClass: "slick-group-checkbox",
    checkboxSelectPlugin: null,
    columnId: "_checkbox",
    cssClass: null,
    toolTip: "Select/Deselect All",
    width: 30
};


function isDataItem(item) {
    /// <summary>
    /// Returns true if item represents actual data item, but not group nor totals.
    /// </summary>

    return item && !item.__group && !item.__groupTotals;
}


function isDataRow(data, row) {
    /// <summary>
    /// Returns true if item at given row is not Group and not Group Total row.
    /// </summary>

    return isDataItem(data.getItem(row));
}


// --------------------------------------------
// Groups + checkbox selection plugin

function GroupSelectionPlugin(options) {
    /// <summary>
    /// Group item metadata provider that uses checkboxes for multiselect.
    /// </summary>

    this.handlers = new slickCore.EventHandler();
    this.options = $.extend({}, defaultOptions, options);

    this.onColumnFilterClick = new slickCore.Event();
    this.onSelectedIdsChange = new slickCore.Event();

    this.selectedIds = {};
}


GroupSelectionPlugin.prototype.init = function init(grid) {
    /// <summary>
    /// Initializes properties and subscriptions.
    /// </summary>

    var gridData = grid.getData();

    this.grid = grid;
    this.multiSelect = grid.getOptions().multiSelect;

    // subscribe to grid events
    this.handlers.subscribe(grid.onClick, GroupSelectionPlugin.prototype._onClickHandler.bind(this));
    this.handlers.subscribe(grid.onDblClick, GroupSelectionPlugin.prototype._onDblClickHandler.bind(this));
    this.handlers.subscribe(grid.onHeaderClick, GroupSelectionPlugin.prototype._onHeaderClickHandler.bind(this));
    this.handlers.subscribe(grid.onActiveCellChanged, GroupSelectionPlugin.prototype._onActiveCellChangedHandler.bind(this));
    this.handlers.subscribe(grid.onContextMenu, GroupSelectionPlugin.prototype._onContextMenuHandler.bind(this));
    this.handlers.subscribe(grid.onHeaderCellRendered, GroupSelectionPlugin.prototype._onHeaderCellRenderedHandler.bind(this));
    this.handlers.subscribe(gridData.onRowCountChanged, GroupSelectionPlugin.prototype._onRowCountChangedHandler.bind(this));
    this.handlers.subscribe(gridData.onRowsChanged, GroupSelectionPlugin.prototype._onRowsChangedHandler.bind(this));

    // init group item metadata provider
    this.hookGetItemMetadata();
};


GroupSelectionPlugin.prototype.destroy = function () {
    /// <summary>
    /// Disposes all subscriptions.
    /// </summary>

    this.handlers.unsubscribeAll();
    this.grid.getData().getItemMetadata = this._originalDataViewGetItemMetadata;
};


GroupSelectionPlugin.prototype.hookGetItemMetadata = function () {
    /// <summary>
    /// Initializes provided group item metadata for a data view.
    /// </summary>
    /// <param name="provider"></param>

    var data = this.grid.getData(),
        formatterFactory = this.grid.getOptions().formatterFactory,
        self = this;

    function getGroupRowMetadata(item) {
        /// <summary>
        /// Returns group row metadata, that contains also group cell formatter.
        /// </summary>
        self._groupRowMetadata = self._groupRowMetadata || {
            selectable: self.options.groupSelectable,
            focusable: self.options.groupFocusable,
            cssClasses: self.options.groupCssClass,
            columns: {
                0: {
                    formatter: self.defaultGroupCellFormatter.bind(self),
                    editor: null
                }
            }
        };

        // Adjust width of group title column (0) based on whether
        // totals are being displayed. These need to be adjusted every
        // time the metadata is retrieved in case column positions have changed.
        self._groupRowMetadata.columns[0].colspan = (item.displayHeaderTotals && item.headerTitleColspan >= 0
            ? item.headerTitleColspan
            : "*"); // fit to the width of the table by default

        return self._groupRowMetadata;
    }

    function getTotalsRowMetadata() {
        /// <summary>
        /// Returns totals row metadata.
        /// </summary>
        self._totalsRowMetadata = self._totalsRowMetadata || {
            selectable: self.options.totalsSelectable,
            focusable: self.options.totalsFocusable,
            cssClasses: self.options.totalsCssClass,
            formatter: self.options.totalsFormatter || (formatterFactory && formatterFactory.totalsFormatter),
            editor: null
        };
        return self._totalsRowMetadata;
    }

    this._originalDataViewGetItemMetadata = data.getItemMetadata;

    data.getItemMetadata = function getItemMetadata(row) {
        var metadata, item = data.getItem(row);

        // overrides for grouping rows
        if (item && item.__group) {
            return getGroupRowMetadata(item);
        }

        // overrides for totals rows
        if (item && item.__groupTotals) {
            return getTotalsRowMetadata(item);
        }

        // get original item metadata
        metadata = self._originalDataViewGetItemMetadata(row);

        // first group item row decorate with "first" class
        if (row !== 0 && isDataRow(data, row) && !isDataRow(data, row - 1)) {
            metadata = metadata || {};
            metadata.cssClasses = (metadata.cssClasses || "") + "first ";
        }

        // last group item row decorate with "last" class
        if (isDataRow(data, row) && !isDataRow(data, row + 1)) {
            metadata = metadata || {};
            metadata.cssClasses = (metadata.cssClasses || "") + "last ";
        }

        return metadata;
    };
};


GroupSelectionPlugin.prototype.getCheckboxColumnDefinition = function () {
    /// <summary>
    /// Returns checkbox column definition (the first column in grid when in multi select mode).
    /// </summary>

    // Remove row checkboxes out of the tab cycle with tabindex='-1'
    // so when slickgrid's tab handler is disabled, tabs
    // are not forced to iterate through each checkbox control.
    var checkbox = "<input type='checkbox' tabindex='-1'/>";
    this.checkboxColumnDefinition = this.checkboxColumnDefinition || {
        id: this.options.columnId,
        name: checkbox,
        toolTip: this.options.toolTip,
        field: "sel",
        width: this.options.width,
        resizable: false,
        sortable: false,
        movable: false,
        cssClass: this.options.cssClass,
        filterable: false,
        supportsContext: false,
        formatter: this.checkboxSelectionFormatter.bind(this)
    };
    return this.checkboxColumnDefinition;
};


GroupSelectionPlugin.prototype.toggleGroup = function (group) {
    /// <summary>
    /// Expands/collapses group depending on it's current state and syncronizes selection.
    /// </summary>
    /// <param name="group">Group item.</param>

    if (group.collapsed) {
        this.grid.getData().expandGroup(group.groupingKey);
    } else {
        this.grid.getData().collapseGroup(group.groupingKey);
    }
    this.syncSelectedRows();
};


/**
 * Expands/collapses all groups depending on the state of the provided group.
 *
 * @param group
 *     Group item.
 */
GroupSelectionPlugin.prototype.toggleAllGroups = function (group) {
    if (group.collapsed) {
        this.grid.getData().expandAllGroups(group.level);
    } else {
        this.grid.getData().collapseAllGroups(group.level);
    }
    this.syncSelectedRows();
};


GroupSelectionPlugin.prototype.isGroupSelected = function (group) {
    /// <summary>
    /// Returns "true" if given group item contains only selected rows.
    /// </summary>
    /// <param name="group">Groups item.</param>

    var i, rows, l, id, idField = this.grid.getOptions().idField;

    for (i = 0, rows = group.rows, l = group.rows.length; i < l; i += 1) {
        id = rows[i][idField];
        if (!this.selectedIds[id]) {
            return false;
        }
    }
    return true;
};


GroupSelectionPlugin.prototype.syncSelectedRows = function () {
    /// <summary>
    /// Select grid rows depending on selected items.
    /// </summary>

    this.selectRowsByIds(this.selectedIds);
};


GroupSelectionPlugin.prototype.selectAll = function (all) {
    /// <summary>
    /// Checks/unchecks all rows.
    /// Only makes sense in multi selection mode.
    /// </summary>
    /// <param name="all">true to check.</param>
    var i, id, items, l, idField = this.grid.getOptions().idField;

    if (this.multiSelect) {
        // check all rows
        if (all) {
            for (i = 0, items = this.grid.getData().getItems(), l = items.length; i < l; i += 1) {
                id = items[i][idField];
                this.selectedIds[id] = true;
            }
        } else {
            this.selectedIds = {};
        }

        this.syncSelectedRows();

        this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
    }
};


GroupSelectionPlugin.prototype.selectRowsByIds = function (ids) {

    var item, rows = [], count = 0, id,
        getRowById = this.grid.getData().getRowById,
        getItemById = this.grid.getData().getItemById;

    this.selectedIds = ids;

    for (id in ids) {
        if (ids.hasOwnProperty(id) && ids[id]) {
            item = getItemById(id);
            if (item) {
                rows.push(getRowById(id));
                count += 1;
            } else {
                // remove id from "selected" dictionary
                // if items array doesn't have an item with given id
                delete ids[id];
            }
        }
    }

    this.grid.setSelectedRows(rows);

    // invalidate whole grid, so all checkboxes are rerendered
    if (this.multiSelect) {
        this.grid.invalidate();
    }

    // check/uncheck column checkbox
    // Remove row checkboxes out of the tab cycle with tabindex='-1'
    // so when slickgrid's tab handler is disabled, tabs
    // are not forced to iterate through each checkbox control.
    if (count > 0 && this.grid.getData().getItems().length === count) {
        this.grid.updateColumnHeader(this.options.columnId, "<input type='checkbox' checked='checked' tabindex='-1' />", this.options.toolTip);
    } else {
        this.grid.updateColumnHeader(this.options.columnId, "<input type='checkbox' tabindex='-1' />", this.options.toolTip);
    }
};


GroupSelectionPlugin.prototype.checkboxSelectionFormatter = function (row, cell, value, columnDef, dataContext) {
    /// <summary>
    /// Cell formatter of checkbox column.
    /// </summary>

    if (dataContext) {
        var id = this.grid.getData().mapRowsToIds([row])[0];
        // Remove row checkboxes out of the tab cycle with tabindex='-1'
        // so when slickgrid's tab handler is disabled, tabs
        // are not forced to iterate through each checkbox control.
        return this.selectedIds[id]
            ? "<input type='checkbox' checked='checked' tabindex='-1' />"
            : "<input type='checkbox' tabindex='-1' />";
    }
    return null;
};


GroupSelectionPlugin.prototype.defaultGroupCellFormatter = function (row, cell, value, columnDef, item) {
    /// <summary>
    /// Group cell formatter.
    /// </summary>

    var indentation = (this.multiSelect ? item.level + 1 : item.level) * 15 + "px",
        checkbox;
    if (this.multiSelect) {
        // Remove row checkboxes out of the tab cycle with tabindex='-1'
        // so when slickgrid's tab handler is disabled, tabs
        // are not forced to iterate through each checkbox control.
        checkbox = this.isGroupSelected(item)
            ? "<input type='checkbox' tabindex='-1' class='" + this.options.checkboxCssClass + "' checked='checked' />"
            : "<input type='checkbox' tabindex='-1' class='" + this.options.checkboxCssClass + "' />";
    } else {
        checkbox = "";
    }

    return [
        checkbox,
        '<span style="margin-left:',
        indentation,
        '" class="',
        this.options.toggleCssClass,
        ' ',
        (item.collapsed ? this.options.toggleCollapsedCssClass : this.options.toggleExpandedCssClass),
        '"></span>',
        '<span title="Double Click to ',
        item.collapsed ? 'Expand ' : 'Collapse ',
        '">',
        item.title,
        '</span>'
    ].join("");
};


GroupSelectionPlugin.prototype.getClosestFocusableRow = function (grid, row, step) {
    /// <summary>
    /// Returns closest focusable row to given one.
    /// </summary>

    var length = grid.getDataLength();
    while (row >= 0 && row < length && !grid.canCellBeActive(row, 0)) {
        row += step;
    }
    return row;
};


GroupSelectionPlugin.prototype.navigateAndSelectUpOrDown = function (isDownNav, grid) {
    /// <summary>
    /// Selects next row when navigating up/down.
    /// </summary>

    var activeRow = grid.getActiveCell(),
        dir = isDownNav ? 1 : -1,
        id,
        nextRow,
        dataLength = grid.getDataLength(),
        selected = this.selectedIds,
        idField = this.grid.getOptions().idField;

    if (activeRow) {
        if (this.multiSelect) {
            nextRow = activeRow.row;

            id = grid.getDataItem(activeRow.row)[idField];
            selected[id] = true;

            do {
                nextRow = nextRow + dir;
            } while (!grid.canCellBeActive(nextRow, activeRow.cell) && nextRow >= 0 && nextRow < dataLength);

            if (nextRow >= 0 && nextRow < dataLength) {
                id = grid.getDataItem(nextRow)[idField];
                selected[id] = true;
            }
        } else {
            selected = {};
        }

        this.selectedIds = selected;
        this.syncSelectedRows();
        this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);

        if (isDownNav) {
            grid.navigateDown();
        } else {
            grid.navigateUp();
        }
    }
};


GroupSelectionPlugin.prototype.navigateHomeOrEnd = function (isHomeNav, selectRows, grid) {
    /// <summary>
    /// Selects all rows from currently focused row to the first or last one.
    /// </summary>

    var i, l, activeRow = grid.getActiveCell(),
        lastRow = activeRow && activeRow.row,
        idField = this.grid.getOptions().idField;

    if (activeRow && selectRows) {
        if (this.multiSelect) {
            for (i = isHomeNav ? 0 : activeRow.row, l = isHomeNav ? activeRow.row + 1 : grid.getDataLength(); i < l; i += 1) {
                if (grid.canCellBeActive(i, activeRow.cell)) {
                    this.selectedIds[grid.getDataItem(i)[idField]] = true;
                    lastRow = i;
                }
            }
            this.syncSelectedRows();

            grid.gotoCell(isHomeNav ? 0 : lastRow, 0);
        }
    } else {
        if (isHomeNav) {
            grid.gotoCell(this.getClosestFocusableRow(grid, 0, 1), 0);
        } else {
            grid.gotoCell(this.getClosestFocusableRow(grid, grid.getDataLength() - 1, -1), 0);
        }
    }
};



GroupSelectionPlugin.prototype.toggleRowSelection = function (row) {
    /// <summary>
    /// Given grid row, toggles its selection.
    /// </summary>
    /// <param name="row">Grid row.</param>

    var i, l, checked, idField, id, item = this.grid.getData().getItem(row);

    if (!item) { return; }

    if (item.__group) {
        checked = this.isGroupSelected(item);
        idField = this.grid.getOptions().idField;

        for (i = 0, l = item.rows.length; i < l; i += 1) {
            this.selectedIds[item.rows[i][idField]] = !checked;
        }
    } else {
        id = item[this.grid.getOptions().idField];
        this.selectedIds[id] = !this.selectedIds[id];
    }

    this.syncSelectedRows();

    this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
};


// --------------------------------------------
// Handling Slick Grid events


GroupSelectionPlugin.prototype._onClickHandler = function (e, args) {
    /// <summary>
    /// Handle click;
    /// </summary>

    var from, to, cell, i, dir, id,
        item = args.grid.getDataItem(args.row),
        idField = this.grid.getOptions().idField,
        dataView = this.grid.getData();

    if (this.multiSelect && e.ctrlKey) {
        // ctrl + click: toggle row selection

        cell = args.grid.getCellFromEvent(e);
        if (item && args.grid.canCellBeActive(cell.row, cell.cell)) {
            id = item[idField];

            if (isDataItem(item)) {
                this.selectedIds[id] = !this.selectedIds[id];
            }

            this.syncSelectedRows();
            this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);

            args.grid.gotoCell(cell.row, 0);
            args.grid.focus();
        }

        // we don't want to allow slick grid to select anything
        e.stopImmediatePropagation();

    }

    if (this.multiSelect && e.shiftKey) {
        // shift + click: select range from last focused to clicked row

        from = args.grid.getActiveCell();
        to = args.grid.getCellFromEvent(e);
        if (to && args.grid.canCellBeActive(to.row, to.cell)) {
            from = from || to;

            from = from.row;
            to = to.row;
            dir = (from < to) ? 1 : -1;
            for (i = from; (dir > 0 && i <= to) || (dir < 0 && i >= to); i += dir) {
                item = dataView.getItem(i);
                id = item[idField];
                if (isDataItem(item)) {
                    // we care only items itself - not group or total rows
                    this.selectedIds[id] = true;
                }
            }

            this.syncSelectedRows();
            this.onSelectedIdsChange.notify({ ids: this.selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);

            args.grid.gotoCell(to, 0);
            args.grid.focus();
        }

        // we don't want to allow slick grid to select anything
        e.stopImmediatePropagation();
    }

    if (item && item.__group) {

        if ($(e.target).hasClass(this.options.toggleCssClass)) {
            if (e.ctrlKey || e.metaKey) { // ctrl+click or cmd+click
                this.toggleAllGroups(item);
            } else {
                this.toggleGroup(item);
            }
        } else if ($(e.target).hasClass(this.options.checkboxCssClass)) {
            this.toggleRowSelection(args.row);
        }

        e.stopImmediatePropagation();
        args.grid.gotoCell(args.row, 0);
    } else if (!e.shiftKey && args.grid.getColumns()[args.cell].id === this.options.columnId) { // clicking on a row select checkbox
        this.toggleRowSelection(args.row);

        e.stopImmediatePropagation();
        args.grid.gotoCell(args.row, 0);
        args.grid.focus();
    }
};


GroupSelectionPlugin.prototype._onDblClickHandler = function (e, args) {
    /// <summary>
    /// Handles dbl click.
    /// </summary>

    var item = args.grid.getDataItem(args.row);
    if (item && item.__group) {
        this.toggleGroup(item);

        // we don't want to select a text dbl-clicked in group row
        e.preventDefault();
    }
};


GroupSelectionPlugin.prototype._onHeaderClickHandler = function (e, args) {
    /// <summary>
    /// Handles header checkbox click to select/unselect all.
    /// </summary>

    if (args.column.id === this.options.columnId && $(e.target).is(":checkbox")) {
        this.selectAll($(e.target).is(":checked"));
        e.stopImmediatePropagation();

        // reset focus
        var active = args.grid.getActiveCell();
        if (active) {
            args.grid.gotoCell(active.row, 0);
            args.grid.focus();
        }
    }
};


GroupSelectionPlugin.prototype._onRowCountChangedHandler = function () {
    /// <summary>
    /// Rerenders grid when rows count is changed.
    /// </summary>

    this._requiresRender(this._lastFocused);

    // this flag is used in _onRowsChangedHandler to prevent double rendering
    this.rendered = true;
};


GroupSelectionPlugin.prototype._onRowsChangedHandler = function () {
    /// <summary>
    /// Rerenders grid when rows are changed.
    /// </summary>

    if (this.rendered === true) {
        delete this.rendered;
        return;
    }

    this._requiresRender(this._lastFocused);
};


GroupSelectionPlugin.prototype._requiresRender = function (lastFocused) {
    /// <summary>
    /// Render grid restoring last focus and selection
    /// </summary>

    this.grid.invalidate();

    if (lastFocused) {
        // make sure also active row now is not one that cannot be active
        if (lastFocused.itemId) {
            var row = this.grid.getData().getRowById(lastFocused.itemId);
            if (row >= 0) {
                // we need it after sorting and new items array to refocus previously focused item
                this.grid.gotoCell(row, 0);
            } else {
                // if previously focused item was removed due to new items - focus an item at the same position
                this.grid.gotoCell(lastFocused.row, 0);
            }
        }
    }

    this.syncSelectedRows();
};


GroupSelectionPlugin.prototype._onActiveCellChangedHandler = function (e, args) {
    /// <summary>
    /// Handles header checkbox click to select/unselect all.
    /// </summary>

    var item, selectedIds, idField;

    this._lastFocused = {
        row: args.row,
        itemId: this.grid.getData().mapRowsToIds([args.row])[0]
    };

    // if args.row is undefined, then resetActiveCell() was called programmatically
    // in this case e don't need to sync selected IDs
    if (this.multiSelect || args.row === undefined) { return; }

    item = this.grid.getData().getItem(args.row);
    idField = this.grid.getOptions().idField;
    selectedIds = {};
    if (item && !item.__group) {
        selectedIds[item[idField]] = true;
        this.selectedIds = selectedIds;
        this.syncSelectedRows();
    }

    this.onSelectedIdsChange.notify({ ids: selectedIds, grid: this.grid }, new slickCore.EventData(), this.grid);
};


GroupSelectionPlugin.prototype._onContextMenuHandler = function (e, args) {
    /// <summary>
    /// Focuses right clicked row.
    /// </summary>

    var cell = args.grid.getCellFromEvent(e);

    if (args.grid.canCellBeActive(cell.row, cell.cell)) {
        args.grid.setActiveCell(cell.row, cell.cell);
    }
};


GroupSelectionPlugin.prototype._onHeaderCellRenderedHandler = function (e, args) {
    /// <summary>
    /// Handles rendering of a column header.
    /// </summary>

    // stop propagation of "drag" event if it's not movable
    if (args.column.movable === false) {
        $(args.node).on("drag", function (e) {
            e.stopImmediatePropagation();
        });
    }

    // render filter icon and subscribe to its "click" event
    if (this.options.renderColumnFilterIcon && args.column.filterable !== false) {
        var html = args.column.filtered
                ? "<div class='slick-column-filter'><i class='sprite-filter-16'></i></div>"
                : "<div class='slick-column-filter'><i class='sprite-smallArrowDown-16'></i></div>",
            $html = $(html)
                .on("click", function (event) {
                    this.onColumnFilterClick.notify({ grid: this.grid, column: args.column }, event, this.grid);

                    event.stopImmediatePropagation();
                }.bind(this));

        $(args.node)
            .addClass("slick-header-filter")
            .attr("title", args.column.toolTip || args.column.name)
            .append($html);
    }
};

module.exports = GroupSelectionPlugin;




//////////////////
// WEBPACK FOOTER
// ./~/pli/ko-grid/slick.groupselectionplugin.js
// module id = 440
// module chunks = 49